import { useContext } from 'react';

import {AnnotationContext} from '../context/AnnotationContext';

import AnnotationDetails from './AnnotationDetails';

import '../stylesheets/annotation-list.scss';

/**
 * Component that lists out all the annotations created by the user
 */
function AnnotationList() {
    const annotationContext = useContext(AnnotationContext)
    const {currentAnnotation, imageSrc} = annotationContext
    const selectedLabel = currentAnnotation?.label

    // id format is 00XX.jpg
    const id = imageSrc.slice(-8)


    return (
        <div className="annotation-list">
            {/*<AnnotationDetails*/}
            {/*    annotation={currentAnnotation}*/}
            {/*    selectedLabel={selectedLabel}*/}
            {/*/>*/}
            {/*Tried extension #1*/}
            {currentAnnotation && currentAnnotation.map((annotation, index) =>
                <AnnotationDetails
                    key={index}
                    annotation={annotation}
                    selectedLabel={selectedLabel}
                />
            )}

        </div>
    )
}

export default AnnotationList
